import env from './env';

export default [
  {
    label: 'Accounts',
    href: '/app/accounts',
    role: 'staff',
  },
  {
    label: 'Account Applications',
    href: '/app/kyc',
    role: 'staff',
  },
  {
    label: 'Application Import',
    href: '/app/application-import',
    role: 'staff',
  },
  {
    label: 'Bank Requests',
    href: '/app/staff/bank-requests',
    role: 'staff',
  },
  {
    label: 'KYC Status',
    href: '/app/staff/account-kyc/worklist',
    role: 'staff',
  },
  {
    label: 'Compliance Status',
    href: '/app/staff/account-compliance/worklist',
    role: 'staff',
  },
  {
    label: 'Client Profile Changes',
    href: '/app/client-profile-changes',
    role: 'staff',
  },
  {
    label: 'Holdings',
    href: '/app/holdings',
    role: 'staff',
  },
  {
    label: 'Portfolio Models',
    href: '/app/portfolio-models',
    role: 'staff',
  },
  {
    label: 'Asset Classes',
    href: '/app/asset-classes',
    role: 'staff',
  },
  {
    label: 'Custodian Data Imports',
    href: '/app/data-imports',
    role: 'staff',
  },
  {
    label: 'Custodian Commands',
    href: '/staff/custodian-commands',
    role: 'staff',
  },
  {
    label: 'Documents',
    href: '/app/documents',
    role: 'user',
    excludeRole: 'staff',
  },
  {
    label: 'Statements',
    href: '/app/statements',
    role: 'user',
    enabled: env.FEATURE_STATEMENTS,
  },
  {
    label: 'Staff Withdrawals',
    href: '/app/staff/staff-withdrawal-requests',
    role: 'staff',
  },
  {
    label: 'Transfers',
    href: '/app/transfers',
    role: 'staff',
  },
  {
    label: 'Reports',
    href: '/app/admin/reports',
    role: 'staff',
  },
  {
    label: 'Profile',
    href: '/app/profile',
    role: 'user',
    excludeRole: 'staff',
  },
  {
    label: 'Tools',
    href: '/tools',
    role: 'user',
    target: '_blank',
    enabled: env.FEATURE_TOOLS,
  },
  {
    label: 'Blog',
    href: 'https://blog.cidirectinvesting.com',
    role: 'user',
    target: '_blank',
    enabled: env.FEATURE_BLOG,
  },
  {
    label: 'Support',
    href: env.FEATURE_SUPPORT_URL || 'https://help.cidirectinvesting.com',
    role: 'user',
    target: '_blank',
  },
  {
    label: 'Demo Admin',
    href: '/app/admin/demo',
    role: 'staff',
  },
  {
    label: 'Billing',
    href: '/app/billing',
    role: 'staff',
  },
  {
    label: 'Process Queue Requests',
    href: '/app/staff/process-queue-requests',
    role: 'staff',
  },
  {
    label: 'Advisor Change Requests',
    href: '/app/staff/advisor-change-requests',
    role: 'advisor_tools',
  },
  {
    label: 'Advisor Access Toggles',
    href: '/app/staff/advisor-access-toggles',
    role: 'advisor_tools',
  },
];
